import clsx from 'clsx';

import { flexDirectionClasses } from '../classes/flexDirectionClasses';
import type { Adaptive } from '../types/Adaptive';
import type { FlexDirection } from '../types/FlexDirection';

export function composeFlexDirectionClasses(color: Adaptive<FlexDirection>): string {
    if (typeof color === 'object') {
        return clsx(
            color.base && flexDirectionClasses[color.base],
            color.sm && `sm:${flexDirectionClasses[color.sm]}`,
            color.md && `md:${flexDirectionClasses[color.md]}`,
            color.lg && `lg:${flexDirectionClasses[color.lg]}`,
            color.xl && `xl:${flexDirectionClasses[color.xl]}`,
            color['2xl'] && `2xl:${flexDirectionClasses[color['2xl']]}`
        );
    }

    return flexDirectionClasses[color];
}
